import styled from 'styled-components';
import { HotPriceCircle } from '@lt/components/icons-react/userflow';

export const HotPriceIcon = styled(HotPriceCircle)`
  width: 16px;
  height: 15px;
  margin-right: 4px;
  margin-left: 6px;
`;
